import withIntl, { IntlPropType } from '../../../shared/react-hocs/intl-hoc';

import getIntlFromState from './intl';

export { IntlPropType };

export default (WrappedComponent) => withIntl(WrappedComponent, getIntlFromState);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/intl-hoc.js